/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {injectIntl} from 'react-intl'
import {withRouter} from "react-router"
import {Button, Card, Grid} from '@scuf/common'
import Loader from '../../common/Loader'
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import * as FleetsActions from './FleetsActions'
import {Routes} from "../../utils/Routes";
import FleetsHierarchy from "../common/FleetsHierarchy";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";

class Fleets extends React.Component {

    constructor(props) {
        super(props)

        this.fleetChanged = this.fleetChanged.bind(this)
    }

    componentDidMount() {
        this.fetchFleets()
    }


    fetchFleets() {
        this.props.FleetsActions.fetchFleetsHierarchy(true)
    }

    fleetChanged(fleetIds) {
        const {history} = this.props;

        if(fleetIds[0].indexOf('fleet_') !== -1) {
            history.push(Routes.FLEETS_ADMIN + "/" + fleetIds[0].substr('fleet_'.length))
        } else if (fleetIds[0].indexOf('asset_') !== -1) {
            history.push(Routes.ASSETS_ADMIN + "/" + fleetIds[0].substr('asset_'.length))
        } else {
            // No history should be pushed otherwise
        }

    }

    isReadOnly() {
        return !userHasActivity(this.props.userProfile, ACTIVITY_TYPES.FLEETS_WRITE)
    }

    render() {
        const {intl, fleetsHierarchy, loading} = this.props

        return (
            <React.Fragment>
                <Loader loading={loading}/>
                <Grid id="fleet-administration">
                    <Grid.Row>
                        <Grid.Column className={"buttonsInRow"}>
                            <div className="admin-fleets-create-buttons-div">
                                <Button
                                    type="primary"
                                    content={intl.formatMessage({id: "admin.asset.create.title"})}
                                    onClick={() => this.props.history.push(Routes.ASSETS_ADMIN+"/new")}
                                    disabled={this.isReadOnly()}
                                    className="mobile-max-width-button"
                                />
                                <Button
                                    type="primary"
                                    content={intl.formatMessage({id: "admin.fleets.create"})}
                                    onClick={() => this.props.history.push(Routes.FLEETS_ADMIN+"/new")}
                                    disabled={this.isReadOnly()}
                                    className="mobile-max-width-button"
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Card>
                                <Card.Header >

                                </Card.Header>
                                <Card.Content>
                                    <FleetsHierarchy fleetsHierarchy={fleetsHierarchy} asDropdown={false}
                                                     selectionChanged={this.fleetChanged} rootSelectable={false}
                                                     selectableFleetParentsOnly={false} selectableAssetParentsOnly={false}
                                                     showAssets={true}
                                                     placeholder={intl.formatMessage({id:"admin.fleets.selector"})}
                                    />
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fleetsHierarchy: state.fleetsReducer.fleetsHierarchy,
        userProfile: state.security.userProfile,
        loading: state.fleetsReducer.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FleetsActions: bindActionCreators(FleetsActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Fleets)))

